import { store } from '../../../../resources/frontend/js/store';

export const fillLinkedFormInput = (linkedFormInputIdentifier, answerValue) => {
    // linked form input was not set
    if(!linkedFormInputIdentifier) return;

    store.commit('form/addLinkedFormInput', {
        uuid: linkedFormInputIdentifier,
        value: answerValue,
    });
};
